import { render, staticRenderFns } from "./WidgetProductReviewsExternalMobile.vue?vue&type=template&id=006f6e0a"
import script from "./WidgetProductReviewsExternalMobile.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsExternalMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports